<template>
  <v-flex v-if="widget.type === 'INSTANT'">
    <m-pay-edit-dialog
      :show="showDialog"
      :title="dialog.description"
      :item="selectedItem"
      @yes="dialog.action"
      @cancel="hideEditDialog"
      @submit="updateItem"
      maxWidth="700px"
    />
    <m-pay-confirm-dialog
      :show="showConfirmationDialog"
      :title="confirmationDialog.description"
      @yes="confirmationDialog.action"
      @cancel="hideConfirmDialog"
      maxWidth="700px"
    />
    <v-data-table
      :headers="headers"
      :items="widget.config.items"
      :total-items="10"
      :pagination.sync="pagination"
      :loading="loading"
      class="elevation-1 mt-3"
      :style="{'margin-bottom': '10px'}"
      :must-sort="true"
      :rows-per-page-items="[10, 20, 50]"
      :rows-per-page-text="'Rows per page'"
    >

      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>

      <template slot="headers" slot-scope="{}">
        <tr>
          <th v-for="header in headers"
              class="column"
              :class="sortingClasses(header)"
              :key="header.value"
              :style="{ 'min-width': header.width ? `${header.width}px` : '0' }"
              @click="updateSorting(header)">
            <span v-show="'right' !== header.align">{{ header.text }}</span>
            <v-icon v-if="header.sortable === undefined || header.sortable" :small="true">
              {{ $vuetify.icons.sort }}
            </v-icon>
            <span v-show="'right' === header.align">{{ header.text }}</span>
          </th>
        </tr>
      </template>

      <template slot="items" slot-scope="props">
        <tr class="data-table__row">
          <td class="text-xs-left">
            <v-tooltip bottom>
                <span slot="activator">
                  <v-icon color="secondary"
                  @click="editItem(props.item, props.index)">edit</v-icon>
                </span>
              <span>Edit item</span>
            </v-tooltip>
            <v-tooltip bottom>
                <span slot="activator">
                  <v-icon color="secondary"
                    @click="deleteItem(props.index)">delete</v-icon>
                </span>
              <span>Delete item</span>
            </v-tooltip>
            <v-tooltip bottom v-if="widgetItems.length > 1 && props.index > 0">
                <span slot="activator">
                  <v-icon color="secondary"
                    @click="moveUp(props.index)">keyboard_arrow_up</v-icon>
                </span>
              <span>Up</span>
            </v-tooltip>
            <v-tooltip bottom
              v-if="widgetItems.length > 1 && (props.index == 0
              || props.index < widgetItems.length - 1)">
                <span slot="activator">
                  <v-icon color="secondary"
                    @click="moveDown(props.index)">
                    keyboard_arrow_down</v-icon>
                </span>
              <span>Down</span>
            </v-tooltip>
          </td>
          <td class="text-xs-left">{{ props.item.reference }}</td>
          <td class="text-xs-left">{{ props.item.amount }}</td>
          <td class="text-xs-left">{{ props.item.currency }}</td>
          <td class="text-xs-left">{{ props.item.label }}</td>
          <td class="text-xs-left">{{ props.item.taxRate }}</td>
          <td class="text-xs-left">{{ props.item.count }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn large flat color="secondary"
               class="mx-2"
               :loading="loading"
               :disabled="!allowAddItems"
               @click="addItem()">
          Add item
          <v-icon right dark>add</v-icon>
        </v-btn>
    </v-card-actions>
    </v-flex>
</template>

<script>
import MPayEditDialog from './MPayEditDialog';
import MPayConfirmDialog from '../MPayConfirmDialog';

export default {
  name: 'MPayWidgetItemsTable',

  components: {
    MPayEditDialog,
    MPayConfirmDialog,
  },

  props: {
    widgetItems: {
      type: Array,
    },
    widget: {
      type: Object,
    },
    allowAddItems: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
  },

  data: () => ({
    totalWidgetItems: 0,
    headers: [
      { text: '' },
      { text: 'Reference', value: 'reference' },
      { text: 'Amount ', value: 'amount' },
      { text: 'Currency', value: 'currency' },
      { text: 'Label', value: 'label' },
      { text: 'Tax Rate', value: 'taxRate' },
      { text: 'Count', value: 'count' },
    ],
    pagination: {
      sortBy: 'qqq',
      descending: true,
    },
    filtering: {},
    serverReturnedNothing: false,
    showConfirmationDialog: false,
    confirmationDialog: {
      action: () => {
      },
      title: '',
      description: '',
    },
    showDialog: false,
    dialog: {
      action: () => {
      },
      title: '',
      description: '',
    },
    selectedItem: {},
    selectedIndex: -1,
  }),

  methods: {
    resetPagination() {
      this.pagination.page = 1;
    },
    /* eslint-disable no-param-reassign */
    updateFiltering(property, event) {
      const value = event.target.value.trim();
      event.target.value = value;
      this.resetPagination();
      this.filtering[property] = value;
      this.getUsers();
    },
    updateSorting(header) {
      if (header.sortable !== undefined && !header.sortable) {
        return;
      }
      if (this.pagination.sortBy === header.value) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = header.value;
        this.pagination.descending = false;
      }
    },
    sortingClasses(header) {
      const classes = [];
      if (header.sortable !== false) {
        classes.push('sortable');
      }
      if (header.align) {
        classes.push(`text-xs-${header.align}`);
      } else {
        classes.push('text-xs-left');
      }
      const beingSorted = this.pagination.sortBy === header.value;
      if (beingSorted) {
        classes.push('active');
        if (this.pagination.descending) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }
      if (header.text === '') {
        classes.push('px-0');
      }
      return classes;
    },
    addItem() {
      this.selectedItem = { type: this.widget.type, taxRate: 0.21, count: 1 };
      this.selectedIndex = -1;
      this.dialog.title = 'Create Widget item';
      this.showEditDialog('Create widget item ', this.updateItem);
    },
    editItem(item, index) {
      this.selectedItem = item;
      this.selectedIndex = index;
      this.dialog.title = 'Update Widget item';
      this.showEditDialog('Update widget item ', this.updateItem);
    },
    deleteItem(index) {
      this.showConfirmDialog('Delete widget item?', () => {
        this.hideConfirmDialog();
        this.widgetItems.splice(index, 1);
        this.$emit('deleteItem', this.widgetItems);
      });
    },
    hideEditDialog() {
      this.showDialog = false;
    },
    showEditDialog(message, onSuccessCallback) {
      this.showDialog = true;
      this.dialog = {
        title: '',
        description: message,
        action: onSuccessCallback,
      };
    },
    updateItem(item) {
      if (this.selectedIndex > -1) {
        this.widgetItems[this.selectedIndex] = item;
      } else {
        this.widgetItems.push(item);
      }
      this.showDialog = false;
      this.$emit('saveItem', this.widgetItems);
    },
    showConfirmDialog(message, onSuccessCallback) {
      this.showConfirmationDialog = true;
      this.confirmationDialog = {
        title: '',
        description: message,
        action: onSuccessCallback,
      };
    },
    hideConfirmDialog() {
      this.showConfirmationDialog = false;
    },
    moveUp(index) {
      const next = this.widgetItems[index - 1];
      this.widgetItems[index - 1] = this.widgetItems[index];
      this.widgetItems[index] = next;
      this.$emit('saveItem', this.widgetItems);
    },
    moveDown(index) {
      const prev = this.widgetItems[index + 1];
      this.widgetItems[index + 1] = this.widgetItems[index];
      this.widgetItems[index] = prev;
      this.$emit('saveItem', this.widgetItems);
    },
  },

  watch: {
    pagination: {
      handler() {
      },
      deep: true,
    },
  },

};
</script>




// WEBPACK FOOTER //
// src/components/merchant/MPayWidgetItemsTable.vue